const stringUtilities = {
  slugify: (text?: string) => text?.toLowerCase()
    .replace(/ /g, '-')
    .replace('.', '-'),

  sanitizeVariantName: (modelName: string, variantName: string) => {
    const modelWords = modelName?.split(/\s+/);

    if (!modelName) {
      return variantName;
    }

    return variantName?.split(/\s+/)
      .filter((part) => !modelWords.includes(part))
      .join(' ');
  }
}

export default stringUtilities;
